import { useQuery } from "@tanstack/react-query";
import { getStoreList } from "../../modules/Recipe/api";

export const useStoreSelectQueries = ({ storeList }) => {
  const listQuery = useQuery({
    queryKey: ["storeList"],
    queryFn: () => getStoreList(),
    enabled: storeList,
  });
  return { listQuery };
};
